import './login.scss';
import { Auth } from '@shared/Auth';

let isSubmitting = false;

if (document.querySelector('#logintabletBtn')) {
    // main login
    $('#command').on('submit', e => {
        if (isSubmitting) return;

        isSubmitting = true;

        e.stopPropagation();
        e.preventDefault();

        (document.querySelector('#loginBtn') as HTMLButtonElement).disabled = true;

        Auth.clearToken();

        Auth.fetchToken($('#usernameInput').val(), $('#passwordInput').val()).finally(submitForm).catch(submitForm);

        function submitForm() {
            $('#command').off('submit');
            (document.getElementById('command') as HTMLFormElement).submit();
        }
    });
} else {
    // mobile login
    const cleanBtn = document.querySelector('#cleanLoginBtn');
    if (cleanBtn) {
        cleanBtn.addEventListener('click', e => {
            e.preventDefault();
            const formEl = document.querySelector('form');
            const action = formEl.getAttribute('action');
            formEl.setAttribute('action', action + (action.includes('?') ? '&' : '?') + 'no-state');
            formEl.submit();
        });
    }
}
